import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';
import { HOME_PAGE_TITLE, HomePage } from './HomePage';

const homePage = PageBlueprint.make({
  name: 'home',
  params: {
    path: '/home',
    title: HOME_PAGE_TITLE,
    loader: async () => <HomePage />,
  },
});

export const homePageModule = createFrontendModule({
  pluginId: 'app',
  extensions: [homePage],
});
